import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { money } from "@/lib/api";

const ProductCard = ({ product, index = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay: (index % 3) * 0.12, ease: [0.22, 1, 0.36, 1] }}
  >
    <Link
      to={`/shop/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group block laser-card bg-[#0C0C0C] border border-zinc-800/60 hover:border-[#C87455]/40 transition-colors duration-500"
    >
      <div className="aspect-[4/5] overflow-hidden relative">
        <div className="absolute inset-0 spotlight z-[1] opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
        <img src={product.image} alt={product.name} loading="lazy" className="card-img w-full h-full object-cover" />
      </div>
      <div className="px-5 py-5 border-t border-zinc-800/60">
        <div className="flex justify-between items-start gap-3">
          <div>
            <h3 className="font-serif-display text-xl text-white group-hover:text-[#C87455] transition-colors duration-300">
              {product.name}
            </h3>
            <p className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-zinc-500 mt-1">
              {product.method} · {product.material}
            </p>
            {product.colour_upgrade > 0 && (
              <p className="font-mono-tech text-[9px] uppercase tracking-[0.2em] text-[#C87455]/80 mt-1" data-testid={`colour-badge-${product.slug}`}>
                ✦ Colour engraving available
              </p>
            )}
          </div>
          <span className="font-mono-tech text-sm text-[#A9B0B7] shrink-0">
            {product.variants ? `from ${money(product.amount)}` : money(product.amount)}
          </span>
        </div>
      </div>
    </Link>
  </motion.div>
);

export default ProductCard;
